// ToastNotification.js
import React from "react";
import { toast, Toaster } from "react-hot-toast";

const ToastNotification = () => {
  return (
    <Toaster
      position="bottom-left"
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        duration: 4000,
        style: {
          background: "#363636",
          color: "#fff",
        },
        success: {
          duration: 3000,
          style: {
            background: "green",
          },
        },
        error: {
          style: {
            background: "red",
          },
        },
      }}
    />
  );
};

const isTokenPurchaseError = (msg) => {
  if (!msg || typeof msg !== "string") return false;
  const lower = msg.toLowerCase();
  return (
    lower.includes("límite de tokens") ||
    lower.includes("adquiera un nuevo plan") ||
    lower.includes("adquiera un plan") ||
    lower.includes("purchase a new plan") ||
    lower.includes("purchase a plan") ||
    lower.includes("su límite de tokens") ||
    lower.includes("token limit")
  );
};

// Functions to trigger different toast types
export const toastSuccess = (message) => {
  toast.success(message || "Success!");
};

export const toastError = (message) => {
  const msg = message || "algo salió mal!";
  if (isTokenPurchaseError(msg)) {
    toast.error(msg, { id: "token-purchase-error" });
    return;
  }
  toast.error(msg, { id: msg });
};

export default ToastNotification;


